import { render, staticRenderFns } from "./PasskeySettings.vue?vue&type=template&id=4c46feb4&"
import script from "./PasskeySettings.vue?vue&type=script&lang=js&"
export * from "./PasskeySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports